import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MiceNamedRef } from '@voll-intelligence/domain';
import { queryKeys } from '@web/core/query';
import { miceRepository } from '@web/data/repositories';
import { useOrgContext } from '@web/ui/core';

/** Centro de custo de cada viajante do evento (o do viajante, ou o das premissas). */
export function useTravelerCostCenters(projectId: string) {
  const { orgId } = useOrgContext();
  return useQuery({
    queryKey: queryKeys.mice.travelerCostCenters(orgId, projectId),
    queryFn: () => miceRepository.travelerCostCenters(orgId, projectId),
  });
}

/** Os centros de custo que o seletor oferece (os do evento, com ou sem grupo), só lidos quando ele
 *  aparece (`enabled`). */
export function useCostCenterChoices(projectId: string, enabled: boolean): readonly MiceNamedRef[] {
  const { orgId } = useOrgContext();
  const query = useQuery({
    queryKey: queryKeys.mice.travelerCostCenterOptions(orgId, projectId),
    queryFn: () => miceRepository.travelerCostCenterOptions(orgId, projectId),
    enabled,
  });
  return query.data?.costCenters ?? [];
}

/** A troca do operador; sucesso relê os centros de custo e o feed (que registra a troca). Erro: toast padrão. */
export function useSetTravelerCostCenter(projectId: string) {
  const { orgId } = useOrgContext();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: { email: string; costCenterId: string }) =>
      miceRepository.setTravelerCostCenter(orgId, projectId, body),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.mice.travelerCostCenters(orgId, projectId),
        }),
        queryClient.invalidateQueries({ queryKey: queryKeys.mice.activity(orgId, projectId) }),
      ]);
    },
  });
}
